import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import MasterCard from "../../../../assets/icons/MasterCard";
import CardIcon from "../../../../assets/icons/CardIcon";
import VisaCard from "../../../../assets/icons/VisaCard";

import config from 'config';
import Colors from "../../../../utils/Colors";

const styles = {
  mainDiv: {
    height: '50px',
    minWidth: '333px',
    overflowX: 'auto',
    overflowY: 'hidden',
    background: '#F5F8FF',
    border: '1px solid ' + Colors.silverBlueLite,
    margin: '10px 0px'
  },
  cardInfo: {
    float: 'left',
    padding: '3px 15px 3px 15px',
  },
  clientName: {
    fontSize: '16px',
  },
  cardNumber: {
    fontSize: '16px',
  },
  cardIcon: {
    float: 'right',
    padding: '7px 15px 10px 15px',
  },
  cardIconDiv: {
    float: 'left',
    padding: '8px 0 5px 10px'
  },
  cardStyle: {
    height: '35px',
    width: '29px',
  }
};

const CreditCard = ({clientName, cardNumber}) => (
  <div style={styles.mainDiv}>
    <div style={styles.cardIconDiv}>
      <CardIcon/>
    </div>
    <div style={styles.cardInfo}>
      <p style={styles.clientName}>{clientName}</p>
      <p style={styles.cardNumber}>{cardNumber}</p>
    </div>
    <div style={styles.cardIcon}>
      {cardNumber.charAt(0) === config.visaFirstSymbol ? <VisaCard style={styles.cardStyle}/> : <MasterCard style={styles.cardStyle}/>}
    </div>
  </div>
);

CreditCard.propTypes = {
  clientName: PropTypes.string.isRequired,
  cardNumber: PropTypes.string.isRequired,
};

export default Radium(CreditCard);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/billing/CreditCard.jsx